export default {"src":"/_next/static/media/profile-details.1bf5bfbc.svg","height":400,"width":400,"blurWidth":0,"blurHeight":0};